import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { locale as vn } from './i18n/vn';
import { locale as english } from './i18n/en';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls    : ['./not-found-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotFoundPageComponent implements OnInit {
  errorMessage: string;
  errorTitle: string;

  constructor(private route: ActivatedRoute, private _fuseTranslationLoaderService: FuseTranslationLoaderService) {
    this._fuseTranslationLoaderService.loadTranslations(english, vn);
  }

  ngOnInit() {
    this.route.data.subscribe(routeData => {
      this.errorTitle = routeData.errorTitle;
      this.errorMessage = routeData.errorMessage;
    });
  }
}
